import React from 'react';
import Container from '../../../containers/master/semesters/showSemesterContainer';

export default function () {
  return (
    <Container />
  );
}
